import { AboManager as SubscriptionManager } from '@components/aboManager';
import { SubscriptionIntroduction } from '@components/subscriptionIntroduction';

export const TypeMap: Record<string, [React.ComponentType<any>, string]> = {
  SubscriptionIntroduction: [SubscriptionIntroduction, 'showSubscriptionIntroduction'],
  SubscriptionManager: [SubscriptionManager, 'showSubscriptionManager'],
};
